module.exports = __webpack_public_path__ + "media/images/filter-primary-icon-36f28f278c5488b3c1a31ffa72ca13a9.svg";